var exports = {
  "Z": "xcc377c0b--d3b847--layout",
};

module.exports = exports;
